import { graphql } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import { Layout } from '../../components/Layout';
import GlobalStyles from '../components/Layout/GlobalStyles';
import Widgets from '../factories/widgets';
import { getKey } from '../helpers';

// ********************************************************************************
// == LEGACY ======================================================================
// This is a legacy component, it is not recommended to use it along with the new
// project structure and best practices. Once the component is refactored and it no
// longer relies on legacy code, it can be safely removed.
// ................................................................................
// Template for rendering pages created in the Strapi CMS, it uses the Widgets
// component to render the page content. The code below is almost identical
// from that used in the legacy project, with some exceptions:
// - Localization is handled by the i18next plugin
// - The use of the Layout component to wrap the page content
// - Global styles are imported locally, since the new project uses other styling
//   solutions
// SEE: gatsby-node.js
/**
 * Page Template components
 * @param {*} props - component props
 * @returns {JSX}
 */
const Page = (props) => {
  const {
    data,
    pageContext: { /*language: locale,*/ currentPage: pageUri }
  } = props;
  // Locale is obtained from the i18next plugin
  let { language: locale } = useI18next();
  if (!locale) locale = "en";

  const label = getKey(props, `pageContext.${locale}MetaTitle`);
  let meta = getKey(props, `pageContext.${locale}MetaDescription`);
  let keywords = getKey(props, `pageContext.${locale}MetaKeywords`);
  if (!meta || meta.length === 0) {
    meta = label;
  }
  if (!keywords || keywords.length === 0) {
    keywords = 'cbx, crossborder express, tijuana, mexico, usa';
  }
  return (
    <Fragment>
      <Helmet
        title={label}
        meta={[
          { name: 'description', content: meta },
          {
            name: 'keywords',
            content: keywords
          },
          { name: 'viewport', content: 'width=device-width' }
        ]}
      >
        <html lang={locale} />
      </Helmet>
      <Layout {...props}>
        <GlobalStyles>
          <section style={{ width: 'auto', minHeight: 800 }}>
            <Widgets data={data} locale={locale} page_uri={pageUri} />
          </section>
        </GlobalStyles>
      </Layout>
    </Fragment>
  );
};

export const query = graphql`
query WidgetAndLocaleQuery($pageID: String!, $language: String!) {
  widgets: allStrapiWidgetrels(filter: { page: { eq: $pageID } }) {
    edges {
      node {
        ...Widgets
      }
    }
  }
  locales: allLocale(filter: { language: { eq: $language } }) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;

Page.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object
};

export default Page;
